import React from "react";
import styles from "./css/Section3.module.css";
import { ConsultationEng } from "../../svg_groups/consultation_eng";
import { useSelector } from "react-redux";

const Section3 = () => {
  const language = useSelector((state: any) => state.language.value);

  return (
    <div className={styles.frag} style={{ backgroundColor: "#F9F6E9" }}>
      <div className={styles.mainContainer}>
        <div className={styles.road} />
        <div className={styles.childContainer}>
          {language === "EN" && (
            <>
              <div className={styles.header}>
                <div className={styles.storyFreedom}>
                  <span className={styles.myStory1}>My Story:&nbsp;</span>
                  <span className={styles.unDrumSpreLibertate}>
                    A path to freedom
                  </span>
                </div>
                <span className={styles.povesteaMeaUnDrumSpreLibertate}>
                  My story: A path to freedom
                </span>
              </div>
              <div
                className={styles.candPlangeamInCeleMaiFrumoaseLocuriAleLumii}
              >
                <span
                  className={
                    styles.candPlangeamInCeleMaiFrumoaseLocuriAleLumii2
                  }
                >
                  — When I cried in the most beautiful places in the world, in
                  relationships that everyone said were "like in the movies," my
                  soul was actually longing for freedom. The freedom to leave a
                  relationship that seemed perfect to others but didn’t nourish
                  my soul. The freedom to leave a place where I didn’t feel
                  loved the way my heart needed — not "like in the movies," but
                  authentically, deeply, truly.
                  <br />
                </span>
                <span className={styles.candMaStraduiamCuDisperare}>
                  <br />— When I desperately tried to be the most feminine, the
                  sexiest, the best girlfriend, the truth deep inside my soul
                  was different: I wanted freedom. I wanted to free myself from
                  any limitation of being a "good girl," from the norms and
                  expectations imposed by others, and to embrace who I truly
                  was.
                </span>
              </div>
              <div className={styles.noise} />
            </>
          )}
          {language === "RO" && (
            <>
              <div className={styles.header}>
                <div className={styles.storyFreedom}>
                  <span className={styles.myStory1}>Povestea mea:&nbsp;</span>
                  <span className={styles.unDrumSpreLibertate}>
                    Un drum spre libertate
                  </span>
                </div>
                <span className={styles.povesteaMeaUnDrumSpreLibertate}>
                  Povestea mea: Un drum spre libertate
                </span>
              </div>
              <div
                className={styles.candPlangeamInCeleMaiFrumoaseLocuriAleLumii}
              >
                <span
                  className={
                    styles.candPlangeamInCeleMaiFrumoaseLocuriAleLumii2
                  }
                >
                  — Când plângeam în cele mai frumoase locuri ale lumii, în
                  relații despre care toți spuneau că sunt «ca în filme»,
                  sufletul meu tânjea, de fapt, după libertate. Libertatea de a
                  părăsi o relație care părea perfectă pentru alții, dar care nu
                  îmi hrănea sufletul. Libertatea de a pleca dintr-un loc unde
                  nu mă simțeam iubită așa cum avea nevoie inima mea, nu «ca-n
                  filme», ci autentic, profund, real. <br />
                </span>
                <span className={styles.candMaStraduiamCuDisperare}>
                  <br />— Când mă străduiam cu disperare să fiu cea mai
                  feminină, cea mai sexy, cea mai bună iubită, adevărul din
                  adâncul sufletului meu era altul: îmi doream libertate. Voiam
                  să mă eliberez de orice limitare de «fată bună», de normele și
                  așteptările impuse de alții, și de a îmbrățișa cine eram cu
                  adevărat.
                </span>
              </div>
              <div className={styles.noise} />
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default Section3;
